import { useState, useEffect } from 'react';

interface WindowSize {
  width: number;
  height: number;
  isMobile: boolean; // 768px以下をモバイル判定
}

/**
 * ウィンドウサイズを監視する共通フック
 * 複数のコンポーネントで重複していたresize監視を統合
 */
export const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
    isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  });

  useEffect(() => {
    // サーバーサイドレンダリング対応
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setWindowSize({
        width,
        height,
        isMobile: width <= 768,
      });
    };

    // 初期サイズを正確に取得
    handleResize();

    // リサイズイベントリスナーを登録
    window.addEventListener('resize', handleResize);

    // クリーンアップ
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // 依存配列は空 - マウント時のみ実行

  return windowSize;
};
